import { useCallback } from 'react';
import { GetMeQuery } from '@/generated/gql/graphql';
import useUserDetails from '@/shared/data/useUserDetails';

/**
 * Returns true if the user's account segment is Sun or Sweet, qualifying the account to notify SRM.
 *
 * @returns boolean
 */
const useIsAccountQualifiedToNotifySrm = () => {
  const { data: segment } = useUserDetails(useCallback((user: GetMeQuery) => user.me?.account?.segment, []));

  return segment ? ['Sun', 'Sweet'].includes(segment) : false;
};

export default useIsAccountQualifiedToNotifySrm;
